<template>
    <v-alert
        v-if="html"
        :border="border"
        colored-border
        :icon="icon"
        elevation="2"
        :class="`alerttop ${classes}`"
        v-html="html"
    ></v-alert>
    <v-alert
        v-else
        :border="border"
        colored-border
        :icon="icon"
        elevation="2"
        :class="`alerttop ${classes}`"
    >
        <slot></slot>
    </v-alert>
</template>

<script>
export default {
    props: {
        border: {
            type: String,
            default: "bottom"
        },
        icon: {
            type: String,
            default: "fas fa-exclamation-triangle"
        },
        classes: {
            type: String,
            default: ""
        },
        codeHtml: {
            type: [String, Boolean],
            default: false
        }
    },
    data() {
        return {
            borderAlertColor: "",
            iconAlertColor: "",
            bgAlertColor: "",
            html: false
        }
    },
    created() {
        this.borderAlertColor = "#fb8c01";    
        this.iconAlertColor = "#ffffff";    
        this.bgAlertColor = "#FFDBAC";   
    },
    mounted() {
        document.querySelectorAll(".alerttop").forEach(x => { x.setAttribute("style", "background:"+this.bgAlertColor); });
        document.querySelectorAll(".v-alert__icon").forEach( x => { x.setAttribute("style", "color: "+this.iconAlertColor)});
        document.querySelectorAll(".v-alert__border").forEach( x => { x.setAttribute("style", "color: "+this.borderAlertColor)});  
        if(this.codeHtml) {
            this.html = `
            <div class="v-alert__wrapper">
                <i aria-hidden="true" class="v-icon notranslate v-alert__icon fas fa-exclamation-triangle theme--light" style="color: #ffffff"></i>
                <div class="v-alert__content">${this.codeHtml}</div>
                <div class="v-alert__border v-alert__border--bottom v-alert__border--has-color" style="color: #fb8c01"></div>
            </div>
            `;
        }
    }
}
</script>